import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/header';
import Hero from './components/hero';
import About from './components/about';
import TypesOfPKD from './components/typesPkd';
import Genetics from './components/genetics';
import ClinicalFeatures from './components/clinicalFeatures';
import GeneticTesting from './components/geneticTesting';
import ProblemSolving from './components/problemSolving';
import Medication from './components/medication';
import PreventingPKD from './components/prevention';
import FutureTreatment from './components/futureTreatment';
import FAQ from './components/faq';
import ContactForm from './components/contact';

import ReferralPage from './components/referralPage';
import MembershipForm from './components/membershipForm';
import ApplyNewMembershipForm from './components/applyNewMembershipForm';
import Footer from './components/footer';

const Home = () => {
  return (
    <>
      <Header /> 
      <main>
        <Hero />
        <About />
        <TypesOfPKD />
        <Genetics />
        <ClinicalFeatures />
        <GeneticTesting />
        <ProblemSolving />
        <Medication />
        <PreventingPKD />
        <FutureTreatment />
        <FAQ />
      </main>
      <ContactForm />
      
    </>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        
        {/*<Route path="/refer" element={<ReferralPage />} />*/}
        
        {/*<Route path="/membership-form/:urlExtension?" element={<MembershipForm />} />*/}
        
        <Route path="/apply_new_membership" element={<ApplyNewMembershipForm />} />
      </Routes>
    </Router>
  );
}

export default App;